import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiSiteDesignHelperService } from '../../../fi-site-design-helper.service';

export enum BrandColorType {
    Primary,
    Contrast,
    Widgets,
}

export interface IBrandColorData {
    label: string;
    color: string;
    type;
}

@Component({
    selector: 'fi-brand-editor-brand-colors-card',
    templateUrl: './fi-brand-editor-brand-colors-card.component.html',
    styleUrls: ['./fi-brand-editor-brand-colors-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-brand-colors-card' },
    standalone: false,
})
export class FiBrandEditorBrandColorsCardComponent implements OnInit {
    @Input() primaryColor: string;
    @Output() primaryColorChange = new EventEmitter<string>();

    @Input() contrastColor: string;
    @Output() contrastColorChange = new EventEmitter<string>();

    @Input() widgetsColor: string;
    @Output() widgetsColorChange = new EventEmitter<string>();

    brandColorsData: IBrandColorData[];

    constructor(
        private appTextService: AppTextService,
        private fiSiteDesignHelperService: FiSiteDesignHelperService,
    ) {}

    ngOnInit() {
        this.setBrandColorsData();
    }

    private setBrandColorsData() {
        this.brandColorsData = [
            {
                label: this.appTextService.get('common.primary'),
                color: this.primaryColor,
                type: BrandColorType.Primary,
            },
            {
                label: this.appTextService.get('common.contrast'),
                color: this.contrastColor,
                type: BrandColorType.Contrast,
            },
            {
                label: this.appTextService.get('common.widgets'),
                color: this.widgetsColor,
                type: BrandColorType.Widgets,
            },
        ];
    }

    onColorChange(colorValue: string, colorType: BrandColorType) {
        switch (colorType) {
            case BrandColorType.Primary:
                this.primaryColorChange.emit(colorValue);
                break;
            case BrandColorType.Contrast:
                this.contrastColorChange.emit(colorValue);
                break;
            case BrandColorType.Widgets:
                this.widgetsColorChange.emit(colorValue);
                break;
        }
        this.fiSiteDesignHelperService.setBrandSettingsChanged(true);
    }
}
